/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Toasts_Generate_Error_DescriptionInputs */

const es_user_profile_api_keys_toasts_generate_error_description = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Generate_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, intentá nuevamente.`)
};

const en_user_profile_api_keys_toasts_generate_error_description = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Generate_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please try again.`)
};

/**
* | output |
* | --- |
* | "Please try again." |
*
* @param {User_Profile_Api_Keys_Toasts_Generate_Error_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_toasts_generate_error_description = /** @type {((inputs?: User_Profile_Api_Keys_Toasts_Generate_Error_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Toasts_Generate_Error_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_toasts_generate_error_description(inputs)
	return en_user_profile_api_keys_toasts_generate_error_description(inputs)
});
export { user_profile_api_keys_toasts_generate_error_description as "user.profile.api_keys.toasts.generate.error_description" }